module.exports = __webpack_public_path__ + "static/media/1.792c2619.png";